import React, { memo } from "react"
import AccountHolderMain from "@/components/project-dashboard/account-holder-main/"
import ProjectDashboard from "@/components/ProjectDashboard"
import { Routes, Route } from "react-router-dom"
import { useSelector } from "react-redux"
import useTopRoleIsAccountHolder from "@/hooks/useTopRoleIsAccountHolder"

const Dashboard = memo(() => {
    const userData = useSelector((state) => state.userReducer)
    const topRoleIsAccountHolder = useTopRoleIsAccountHolder(userData)

    return (
        <>
            <Routes>
                {topRoleIsAccountHolder ? (
                    <>
                        <Route path="account-holder-main/*" element={<AccountHolderMain userData={userData} />} />
                        <Route path="*" element={<ProjectDashboard />} />
                    </>
                ) : (
                    <Route path="*" element={<ProjectDashboard />} />
                )}
            </Routes>
        </>
    )
})

export default Dashboard
